import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, TableCell, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AREAS_FISICAS, RECLAMOS_ESTADOS } from "../../../../../utils/constants";
import { ModalTrackingReclamoEfector } from "../ModalTrackingReclamo/ModalTrackingReclamoEfector";
import InfoHistorialIcon from "../../../../autorizaciones/UI/InfoHistorialIcon";
import { setSolicitudReclamo } from "../../../../../actions/reclamos/reclamosActions";
import IconEstado from "../../../../autorizaciones/UI/IconEstado";
import { ModalDetalleReclamoEfector } from "../ModalDetalleReclamo/ModalDetalleReclamoEfector";
import { CambioEstadoReclamoEfector } from "./CambioEstadoReclamoEfector";
import { ModalComentariosReclamosEfector } from "./ModalComentariosReclamosEfector";

const useRowStyles = makeStyles({
    root: {
      "& > *": {
        borderBottom: "unset",
      },
    },
  });
  
  const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

export const ReclamoEfectorItem = (props) => {

const classes = useRowStyles();
  const dispatch = useDispatch();
  const { item, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin } = props;
  const [openModalAuditar, setOpenModalAuditar] = useState(false);
  const [openModalCambioEstado, setOpenModalCambioEstado] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] =
    useState(false);
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [idClave, setIdClave] = useState(false);
  const [descripcion, setDescripcion] = useState(false);

  const disabled =
    item?.estado === RECLAMOS_ESTADOS.FINALIZADA ||
    item?.estado === RECLAMOS_ESTADOS.ANULADA;


    
  return (
    <>
    {openModalAuditar && (
      <ModalComentariosReclamosEfector
        disabled={disabled}
        open={openModalAuditar}
        closeModalHandler={() => {
          setOpenModalAuditar(false);
        }}
        solicitud={item}
        fechaInicio={fechaInicio}
        fechaFin={fechaFin}
      />
    )}
    {openModalInfo && (
      <ModalTrackingReclamoEfector
        open={openModalInfo}
        onClose={() => setOpenModalInfo(false)}
        idClave={idClave}
        descripcion={descripcion}
      />
    )}
    {openModalHistorialCambios && (
      <ModalDetalleReclamoEfector
        open={openModalHistorialCambios}
        closeModalHandler={() => {
          setOpenModalHistorialCambios(false);
        }}
        solicitud={item}
        disabled={true}
      />
    )}
    {openModalCambioEstado && (
      <CambioEstadoReclamoEfector
        open={openModalCambioEstado}
        closeModalHandler={() => {
          setOpenModalCambioEstado(false);
        }}
        solicitud={item}
        disabled={false}
        estadoSolicitudes={estadoSolicitudes}
        areasFisicasUsuario={areasFisicasUsuario}
        fechaInicio={fechaInicio}
        fechaFin={fechaFin}
      />
    )}
    <TableRow className={classes.root}>
      <TableCell align="center" sx={{ padding: "10px" }}>
        <InfoHistorialIcon
          onClick={() => {
            setOpenModalInfo(true);
            setIdClave(item?.id);
            setDescripcion(`${item?.descripcionEfector}`);
          }}
        />
      </TableCell>
      <TableCell disabled={true}
        align="center"
        onClick={() => {
          if (areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES) {
            setOpenModalCambioEstado(true);
            dispatch(setSolicitudReclamo(item));
          }
        }}
        style={{ cursor: 'pointer' }}>
        <IconEstado
          useColorTable={true}
          texto={item?.letraUrgente}
          backgroundColor={item?.colorUrgente}
          descripcion={item?.descripcionUrgente}

        />
      </TableCell>
      <TableCell align="center">
        <IconEstado
          useColorTable={true}
          texto={item?.letraEstado}
          backgroundColor={item?.color}
          descripcion={item?.descripcionEstado}
        />
      </TableCell>
      <TableCell align="left">
        {new Date(item?.fechaCarga).toLocaleString("es", optionsfecha)}
      </TableCell>
      <TableCell align="left">{item?.id}</TableCell>
      <TableCell align="left">{item?.idEfectorFacturacion}</TableCell>
      <TableCell align="left">{item?.descripcionEfector} </TableCell>
      <TableCell align="left">{item?.descripcionTipoReclamo}</TableCell>
      <TableCell align="left">{item?.descripcionTipoOrigen}</TableCell>
      <TableCell align="left">{item?.descripcionCategoriaReclamo}</TableCell>
      {/* <TableCell align="left">{item?.descripcionSeccional}</TableCell> */}
      {/* <TableCell align="left">{item?.descripcionUsuarioCarga}</TableCell> */}
      <TableCell align="left">{item?.derivado}</TableCell>
      <TableCell align="left">{item?.subDerivado}</TableCell>
      {/* <TableCell>
        {item.practicas.length > 0 && (
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        )}
      </TableCell> */}
     
      {item?.estado === RECLAMOS_ESTADOS.FINALIZADA && (
           <TableCell >
            {item?.descripcionTipoErrorReclamo}
            </TableCell>
        )}
     
      <TableCell>
        {item?.estado === RECLAMOS_ESTADOS.PENDIENTE && (
          <Button
            style={{ fontSize: "0.8rem" }}
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenModalAuditar(true);
              dispatch(setSolicitudReclamo(item));
            }}
          >
            Abrir
          </Button>
        )}
        {(item?.estado === RECLAMOS_ESTADOS.ANULADA ||
          item?.estado === RECLAMOS_ESTADOS.FINALIZADA) && (
            <Button
              style={{ fontSize: "0.8rem" }}
              variant="contained"
              color="primary"
              onClick={() => {
                setOpenModalHistorialCambios(true);
                dispatch(setSolicitudReclamo(item));
              }}
            >
              Abrir
            </Button>
          )}
      </TableCell>
    </TableRow>
  </>
  )
}
